<template>
  <section class="elementor-section elementor-top-section elementor-element elementor-element-a7ed4ba elementor-section-boxed elementor-section-height-default elementor-section-height-default">
    <div  class="elementor-container elementor-column-gap-no">
      <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-eed197d">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="elementor-element elementor-element-7d78dbf elementor-position-inline-end elementor-widget__width-auto elementor-mobile-position-inline-end elementor-view-default elementor-invisible elementor-widget elementor-widget-icon-box" data-id="7d78dbf" data-element_type="widget" data-e-type="widget" data-settings="{&quot;_animation&quot;:&quot;slideInUp&quot;,&quot;_animation_tablet&quot;:&quot;none&quot;}" data-widget_type="icon-box.default">
            <div class="elementor-widget-container">
              <div class="elementor-icon-box-wrapper">
                <div class="elementor-icon-box-icon">
                  <span  class="elementor-icon">
                    <i aria-hidden="true" class="vamtamtheme- vamtam-theme-line-titles"></i>
                  </span>
                </div>
                <div class="elementor-icon-box-content">
                  <h5 class="elementor-icon-box-title project-title">
                    <span>{{homeContentStore?.contents?.project?.title}}</span>
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-7819116 elementor-invisible elementor-widget elementor-widget-text-editor" data-id="7819116" data-element_type="widget" data-e-type="widget" data-settings="{&quot;_animation&quot;:&quot;fadeIn&quot;,&quot;_animation_tablet&quot;:&quot;none&quot;,&quot;_animation_delay&quot;:500}" data-widget_type="text-editor.default">
            <div class="elementor-widget-container">
              <p class="project-desc" v-html="homeContentStore.contents.project.descriptions"></p>
            </div>
          </div>
          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-d9e3fa8 vamtam-has-underline-anim elementor-widget elementor-widget-button" data-id="d9e3fa8" data-element_type="widget" data-e-type="widget" data-widget_type="button.default">
            <div class="elementor-widget-container">
              <div class="elementor-button-wrapper">
                <a class="elementor-button elementor-button-link elementor-size-sm" href="projects">
                  <span class="elementor-button-content-wrapper">
                    <span class="elementor-button-text">View all projects</span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- <section class="elementor-section elementor-top-section elementor-element elementor-element-42cf59d elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="42cf59d" data-element_type="section" data-e-type="section">
    <div data-rocket-location-hash="e79d6a44b1a5f789a43c006e4a4edb9c" class="elementor-container elementor-column-gap-no">
      <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-18cba20" data-id="18cba20" data-element_type="column" data-e-type="column">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-feb43ff vamtam-has-hr-layout vamtam-nav-pos-custom elementor-grid-3 elementor-grid-tablet-2 elementor-grid-mobile-1 elementor-posts--thumbnail-top vamtam-has-nav vamtam-has-title-underline-anim vamtam-has-read-more-theme-style elementor-widget elementor-widget-posts" data-id="feb43ff" data-element_type="widget" data-e-type="widget" data-settings="{&quot;vamtam_classic_columns&quot;:&quot;3&quot;,&quot;vamtam_classic_columns_tablet&quot;:&quot;2&quot;,&quot;vamtam_classic_columns_mobile&quot;:&quot;1&quot;,&quot;vamtam_classic_row_gap&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:35,&quot;sizes&quot;:[]},&quot;vamtam_classic_row_gap_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;vamtam_classic_row_gap_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}" data-widget_type="posts.vamtam_classic">
            <div class="elementor-widget-container">
              <div class="elementor-posts-container elementor-posts elementor-posts--skin-vamtam_classic elementor-grid elementor-has-item-ratio" role="list">
                <article v-for="proj in homeContentStore.contents.projects" :key="proj.id" class="elementor-post elementor-grid-item post-6007 post type-post status-publish format-standard has-post-thumbnail hentry category-interior category-projects tag-residential" role="listitem">
                  <div class="vamtam-post-thumb-wrap">
                    <a class="elementor-post__thumbnail__link" :href="`/projects/details/` + proj.slug" tabindex="-1">
                      <div class="elementor-post__thumbnail">
                        <img fetchpriority="high" decoding="async" width="790" height="980" :src="proj.thumbs" class="attachment-full size-full wp-image-2084 entered lazyloaded" alt="" :data-lazy-srcset="`${proj.thumbs} 790w, ${proj.thumbs} 242w, ${proj.thumbs} 768w`" data-lazy-sizes="(max-width: 790px) 100vw, 790px" :data-lazy-src="proj.thumbs" data-ll-status="loaded" sizes="(max-width: 790px) 100vw, 790px" :srcset="`${proj.thumbs} 790w, ${proj.thumbs} 242w, ${proj.thumbs} 768w`">
                        <noscript><img fetchpriority="high" decoding="async" width="790" height="980" :src="`${proj.thumbs}`" class="attachment-full size-full wp-image-2084" alt="" :srcset="`${proj.thumbs} 790w, ${proj.thumbs} 242w, ${proj.thumbs} 768w`" sizes="(max-width: 790px) 100vw, 790px" /></noscript>
                      </div>
                    </a>
                    <div class="vamtam-read-more-wrap">
                      <a class="vamtam-read-more-icon" :href="`/projects/details/` + proj.slug">
                        <i aria-hidden="true" class="vamtamtheme- vamtam-theme-plus"></i>
                      </a>
                      <a class="elementor-post__read-more" :href="`/projects/details/` + proj.slug" :aria-label="proj.projectName" tabindex="-1">
                        View Project
                      </a>
                    </div>
                  </div>
                  <div class="elementor-post__meta-data">
                    <div class="vamtam-post__categories">
                      <span class="list-tag">
                        <a v-if="proj?.categoryId?.parentId === null" :href="`/our-services/category/` + proj.categoryId.slug" :rel="proj.categoryId.name">{{ proj.categoryId.name }}</a>
                        <a v-else :href="`/our-services/details/` + proj?.categoryId?.parentId?.slug + `/` + proj.categoryId.slug" :rel="proj.categoryId.name">{{ proj.categoryId.name }}</a>
                        
                      </span>
                    </div>
                  </div>
                  <div class="elementor-post__text">
                    <h4 class="elementor-post__title">
                      <a :href="`/projects/details/` + proj.slug">
                        {{ proj.projectName }}
                      </a>
                    </h4>
                  </div>
                </article>
              </div>
              <div class="vamtam-nav">
                <span class="vamtam-nav-btn vamtam-nav-btn-prev disabled">
                <i class="vamtamtheme- vamtam-theme-arrow-left"></i>
                </span>
                <span class="vamtam-nav-btn vamtam-nav-btn-next">
                <i class="vamtamtheme- vamtam-theme-arrow-right"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section> -->
  <section class="elementor-section elementor-top-section elementor-element elementor-element-42cf59d elementor-section-boxed elementor-section-height-default elementor-section-height-default">
    <div  class="elementor-container elementor-column-gap-no">
      <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-18cba20">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-feb43ff vamtam-has-hr-layout vamtam-nav-pos-custom elementor-grid-3 elementor-grid-tablet-2 elementor-grid-mobile-1 elementor-posts--thumbnail-top vamtam-has-nav vamtam-has-title-underline-anim vamtam-has-read-more-theme-style elementor-widget elementor-widget-posts" data-id="feb43ff" data-element_type="widget" data-e-type="widget" data-settings="{&quot;vamtam_classic_columns&quot;:&quot;3&quot;,&quot;vamtam_classic_columns_tablet&quot;:&quot;2&quot;,&quot;vamtam_classic_columns_mobile&quot;:&quot;1&quot;,&quot;vamtam_classic_row_gap&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:35,&quot;sizes&quot;:[]},&quot;vamtam_classic_row_gap_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;vamtam_classic_row_gap_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}" data-widget_type="posts.vamtam_classic">
            <div class="elementor-widget-container">
              <div class="elementor-posts-container elementor-posts elementor-posts--skin-vamtam_classic elementor-grid" role="list">
                <article v-for="proj in homeContentStore.contents.projects" :key="proj.id" class="elementor-post elementor-grid-item post-354 post type-post status-publish format-standard has-post-thumbnail hentry category-projects tag-buildings tag-residential" role="listitem">
                  <div class="vamtam-post-thumb-wrap">
                    <a class="elementor-post__thumbnail__link" :href="`/projects/details/` + proj.slug" tabindex="-1" >
                      <div class="elementor-post__thumbnail">
                        <img decoding="async" width="586" height="762" :src="proj.thumbs" class="attachment-full size-full wp-image-281" alt="" :data-lazy-srcset="proj.thumbs + ` 586w, ` + proj.thumbs + ` 231w`" data-lazy-sizes="(max-width: 586px) 100vw, 586px" :data-lazy-src="proj.thumbs" />
                        <noscript><img loading="lazy" decoding="async" width="586" height="762" :src="proj.thumbs" class="attachment-full size-full wp-image-281" alt="" :srcset="proj.thumbs + ` 586w, ` + proj.thumbs + ` 231w`" sizes="(max-width: 586px) 100vw, 586px" /></noscript>
                      </div>
                    </a>
                    <div class="vamtam-read-more-wrap">
                      <a class="vamtam-read-more-icon" :href="`/projects/details/` + proj.slug">
                        <i aria-hidden="true" class="vamtamtheme- vamtam-theme-plus"></i>
                      </a>
                      <a class="elementor-post__read-more" :href="`/projects/details/` + proj.slug" :aria-label="proj.projectName" tabindex="-1" >
                        View Project
                      </a>
                    </div>
                  </div>
                  <div class="elementor-post__meta-data">
                    <div class="vamtam-post__categories">
                      <span class="list-tag">
                        <a v-if="proj?.categoryId?.parentId === null" :href="`/our-services/category/` + proj.categoryId.slug" :rel="proj.categoryId.name">{{ proj.categoryId.name }}</a>
                        <a v-else :href="`/our-services/details/` + proj?.categoryId?.parentId?.slug + `/` + proj.categoryId.slug" :rel="proj.categoryId.name">{{ proj.categoryId.name }}</a>
                        
                      </span>
                      
                      
                    </div>
                  </div>
                  <div class="elementor-post__text">
                    <h4 class="elementor-post__title">
                      <a :href="`/projects/details/` + proj.slug" class="title-project">
                        {{ proj.projectName }}
                      </a>
                    </h4>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import { onMounted } from 'vue'
  import { useHomeContentStore } from '@/stores/homeContentStore'

  const baseUploadURL = process.env.VUE_APP_API_URL;

  export default {
    name: 'ProjectSectionComponent',
    setup() {
      const homeContentStore = useHomeContentStore()

      onMounted(async () => {
        await homeContentStore.fetchContentPage()
      })

      return {
        homeContentStore,
      }
    },
    data() {
      return{
        baseUploadURL: baseUploadURL,
      }
    },
  }
</script>
<style>
  .elementor-kit-5 {
    --e-global-typography-vamtam_h2-projects-title-font-size: 40px;
  }
  
  .elementor-widget-posts.vamtam-has-theme-widget-styles.vamtam-has-hr-layout.vamtam-has-nav .vamtam-nav-btn {
    background-color: #66A89A;
    border: 1px solid #66A89A;
    color: #fff;
  }
</style>
<style scoped>
  .elementor-1905 .elementor-element.elementor-element-a7ed4ba {
    margin-top: 100px;
  }
  .elementor-1905 .elementor-element.elementor-element-42cf59d {
    margin-bottom: 100px;
  }
  .elementor-widget-container p.project-desc{
    /* color: #6F8C82; */
    color: #111111;
    font-size: 30px;
    font-weight: 200;
  }
  .elementor-1905 .elementor-element.elementor-element-7819116 {
    font-size: var(--e-global-typography-vamtam_h2-projects-title-font-size);
  }
  .elementor-1905 .elementor-element .elementor-icon-box-title.project-title {
    color:#006940;
  }
  .elementor-1905 .elementor-element > .elementor-widget-wrap > .elementor-widget:not(.elementor-widget__width-auto):not(.elementor-widget__width-initial):not(:last-child):not(.elementor-absolute) {
    color: #6F8C82;
  }
  .list-tag a {
    color: #fff !important;
    background: #66A89A;
    border-radius: 3px;
    padding: 0px 5px;
    margin-right: 5px;
  }

  .list-tag a:hover{
    background: #4F8F76;
    color: #fff;
  }

  .elementor-kit-5 a.title-project {
    font-size: 18px !important;
    font-weight: 300;
    color: #6F8C82;
  }
  .elementor-kit-5 a.title-project:hover {
    color: #006940;
  }
  .elementor-widget-posts.vamtam-has-theme-widget-styles.vamtam-has-read-more-theme-style.elementor-posts--thumbnail-top .vamtam-post-thumb-wrap .vamtam-read-more-wrap .vamtam-read-more-icon {
    background-color: #66A89A;
    color: #fff;
  }
  .elementor-widget-posts.vamtam-has-theme-widget-styles.vamtam-has-read-more-theme-style.elementor-posts--thumbnail-top .vamtam-post-thumb-wrap .vamtam-read-more-wrap .elementor-post__read-more {
    background-color: #66A89A;
    color: #fff;
  }
</style>